import { useState } from "react";
import { PostCard } from "@/components/PostCard";
import { Clock, ChevronRight, ChevronLeft, Sparkles } from "lucide-react";

export const MemoriesCard = ({ memories, onLike, onReact }) => {
  const [currentIdx, setCurrentIdx] = useState(0);

  if (!memories || memories.length === 0) return null;

  const current = memories[currentIdx];

  const next = () => setCurrentIdx((i) => (i + 1) % memories.length);
  const prev = () => setCurrentIdx((i) => (i - 1 + memories.length) % memories.length);

  return (
    <div
      className="bg-card border border-border rounded-3xl overflow-hidden shadow-sm"
      data-testid="memories-card"
    >
      {/* Header */}
      <div className="flex items-center justify-between px-5 pt-5 pb-3">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#7000FF] to-[#FF8FA3] flex items-center justify-center">
            <Sparkles className="w-4 h-4 text-white" />
          </div>
          <div>
            <h3 className="font-heading font-bold text-sm text-card-foreground">Souvenirs</h3>
            <p className="text-[10px] text-muted-foreground">Ce jour-la...</p>
          </div>
        </div>
        {memories.length > 1 && (
          <div className="flex items-center gap-1">
            <button
              onClick={prev}
              className="p-1 rounded-full bg-muted text-muted-foreground hover:text-card-foreground/80 transition-colors"
              data-testid="memories-prev"
            >
              <ChevronLeft className="w-4 h-4" />
            </button>
            <span className="text-[10px] text-muted-foreground px-1">
              {currentIdx + 1}/{memories.length}
            </span>
            <button
              onClick={next}
              className="p-1 rounded-full bg-muted text-muted-foreground hover:text-card-foreground/80 transition-colors"
              data-testid="memories-next"
            >
              <ChevronRight className="w-4 h-4" />
            </button>
          </div>
        )}
      </div>

      {/* Period label */}
      <div className="px-5 pb-3">
        <span className="inline-flex items-center gap-1.5 text-xs px-3 py-1 rounded-full bg-[#7000FF]/10 text-[#7000FF] border border-[#7000FF]/20">
          <Clock className="w-3 h-3" />
          {current.label} — {current.date}
        </span>
      </div>

      {/* Posts */}
      <div className="px-5 pb-5 space-y-3">
        {current.posts.map((post) => (
          <PostCard
            key={post.id}
            post={post}
            onLike={onLike}
            onReact={onReact}
            compact
          />
        ))}
      </div>
    </div>
  );
};
